import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Route, Routes, Navigate, useNavigate, useLocation } from 'react-router-dom'
import { Box, CircularProgress } from '@mui/material'

import { PrivateLayoutComponent } from '../../ui'
import { Home, Profile, GasApplications, Contact, Settings, PaymentResult } from '../../pages'
import { NotificationsContext } from '../../features/notifications/contexts'
import { useGasAppData } from '../../features/gas-applications'
import { useAjaxContext } from '../../core/ajax'
import { setUserData } from '../../features/profile/slices'
import { useGlobalActions } from '../../features/global'

const BarePrivateRouter = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const { get } = useAjaxContext()
  const userId = useSelector((state) => state.global.authData.user_id)
  const { applications } = useGasAppData()
  const { logoutUser } = useGlobalActions()
  const navigate = useNavigate()

  const [loadingUser, setLoadingUser] = useState(true)

  const { loadNotifications, showNotification } = useContext(NotificationsContext)
  const [notify, setNotify] = useState(null)
  const notifLoader = async (user_id, location) => {
    await loadNotifications(user_id)
    const params = new URLSearchParams(location.search)
    const tryNotify = params.get('notify')
    if (tryNotify) {
      setNotify(parseInt(tryNotify))
    }
  }
  const notifShower = async (notify) => {
    if (notify) {
      try {
        await showNotification(notify)
      } catch (err) {
        console.log('The requested notification was not found')
      }
      setNotify(null)
      const currentParams = new URLSearchParams(location.search)
      currentParams.delete('notify')
      navigate({
        search: '?' + currentParams.toString(),
      })
    }
  }
  useEffect(() => {
    notifLoader(userId, location)
  }, [location, userId]) // eslint-disable-line

  useEffect(() => {
    notifShower(notify)
  }, [notify]) // eslint-disable-line

  useEffect(() => {
    setLoadingUser(true)
    get('/usuario/' + userId)
      .then(({ data }) => {
        dispatch(setUserData(data))
        setLoadingUser(false)
        if (!data['nombre']) navigate('/profile')
      })
      .catch(({ response }) => {
        if (response.status === 403) {
          logoutUser()
        }
        return setLoadingUser(false)
      })
  }, []) // eslint-disable-line

  return (
    <PrivateLayoutComponent>
      {loadingUser || !applications ? (
        <Box
          display="flex"
          height="100%"
          width={'100%'}
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress size={40} />
        </Box>
      ) : (
        <Routes>
          <Route path="/home" element={<Home />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/gas-applications/payment/:appId" element={<PaymentResult />} />
          <Route path="/gas-applications" element={<GasApplications />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/settings" element={<Settings />} />
          <Route
            path="*"
            element={
              <Navigate to={applications.length > 0 ? '/gas-applications' : '/home'} replace />
            }
          />
        </Routes>
      )}
    </PrivateLayoutComponent>
  )
}

export const PrivateRouter = BarePrivateRouter
